/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />

namespace Application.Directives {
    'use strict';

    import Utils = Application.Common.Utils;
    import IStreamStatus = Models.IStreamStatus;
    import IStreamPipe = Models.IStreamPipe;
    import Monitor = Models.Monitor;
    import VideoFeed = Models.VideoFeed;
    import IVideoFeed = Models.IVideoFeed;
    // import IStreamAliveData = Models.IStreamAliveData;
    import IBitRateTrending = Models.IBitRateTrending;
    import NetworkNode = Models.NetworkNode;
    import IStreamPipeNodes = Models.IStreamPipeNodes;

    declare type StreamMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                             $timeout: angular.ITimeoutService,
                                             $location: ng.ILocationService,
                                             streamStatusService: Services.StreamStatusService,
                                             streamPipeService: Services.StreamPipeService,
                                             connectionRoomService: Services.ConnectionRoomService,
                                             modalService: ngModal.IModalService,
                                             networkNodeService: Services.NetworkNodeService,
                                             $q: ng.IQService,
                                             timezoneService: Services.TimezoneService,
                                             $cookies: ng.cookies.ICookiesService,
                                             alarmsService: Services.AlarmsService,
                                             stompService: Services.StompService,
                                             flexCollectorService: Services.FlexCollectorService) => StreamMonitorDirective;

    export interface IStreamMonitorScopeDef {
        model: string;
        removeMonitor: string;
        saveMonitor: string;
        monitorMissing: string;
        showTrending: string;
        showAlarms: string;
    }

    export interface IServiceInfo {
        encoding?: string;
    }

    interface ICriticalAlarm {
        alarmName: string;
        deviceSimplifiedHref: string;
    }

    export interface IStreamMonitorScope extends ng.IScope {
        model: Monitor;
        remove: () => void;
        save: () => void;
        monitorMissing: () => void;
        showTrending: boolean;
        alarmsConfirming: boolean;
        showAlarms: boolean;

        monitorStatus: string;
        seeStream: () => void;
        showHistoricalTraffic: () => void;
        bulkConfirm: () => void;
        thumbnailTimer: angular.IPromise<void>;
        videoTimer: angular.IPromise<void>;
        dataStatus: IStreamStatus;
        streamPipe: IStreamPipe;
        thumbnail: string;
        THUMBNAIL_FAIL_IMG: string;
        videoFeed: IVideoFeed;
        loadVideoFeed: (initial?: boolean) => void;
        serviceInfo: IServiceInfo;
        bitRateTrending: IBitRateTrending[];
        totalCurrentBitrate: string;
        dataTimer: angular.IPromise<void>;
        graphOptions: jquery.flot.plotOptions;
        sourceNode: NetworkNode;
        sinkNode: NetworkNode;
        subscriptionCreate: Services.IEventSubscription;
        subscriptionBulkConfirm: Services.IEventSubscription;
        subscriptionSingleConfirm: Services.IEventSubscription;
        subscriptionBulkConfirmAll: Services.IEventSubscription;
        plotSeries: Object[];
        onPlotHover: (event: JQueryEventObject, pos: jquery.flot.pos, item: jquery.flot.item) => void;
        alarmsInfo: {currentCriticals: ICriticalAlarm[], allCount: number, criticalsCount: number};
        thumbnailLoaded: boolean;
        thumbnailLoadedWatcher: Function;
    }

    export class StreamMonitorDirective implements ng.IDirective {
        public static $name: string = "monitor";
        public static $inject: string[] = [];

        private static THUMBNAIL_LOADING_IMG: string = "images/thumbnail-loading.png";
        private static THUMBNAIL_FAIL_IMG: string = "images/thumbnail-fail.png";

        private static STREAM_DATA_TIMER: number = 5500;

        private static THUMBNAIL_TIMER: number = 4000;
        private static VIDEOFEED_TIMER: number = 2000;
        private static COOKIE_THRESHOLD_VALUE_KEY: string = 'flex_threshold_value_stream_';
        private static COOKIE_THRESHOLD_ENABLED_KEY: string = 'flex_threshold_enabled_stream_';

        public link: (scope: IStreamMonitorScope, element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'AE';
        public transclude: boolean = false;
        public replace: boolean = true;
        public templateUrl: string = 'decorators/monitor-directive.html';
        public scope: IStreamMonitorScopeDef = {
            model: '=',
            removeMonitor: '&',
            saveMonitor: '&',
            monitorMissing: '&',
            showTrending: '=',
            showAlarms: '=',
        };

        /**
         * Factory for the directive
         */
        public static Factory(): StreamMonitorDirectiveCb {
            let directive: StreamMonitorDirectiveCb = ($interval: angular.IIntervalService,
                                                       $timeout: angular.ITimeoutService,
                                                       $location: ng.ILocationService,
                                                       streamStatusService: Services.StreamStatusService,
                                                       streamPipeService: Services.StreamPipeService,
                                                       connectionRoomService: Services.ConnectionRoomService,
                                                       modalService: ngModal.IModalService,
                                                       networkNodeService: Services.NetworkNodeService,
                                                       $q: ng.IQService,
                                                       timezoneService: Services.TimezoneService,
                                                       $cookies: ng.cookies.ICookiesService,
                                                       alarmsService: Services.AlarmsService,
                                                       stompService: Services.StompService,
                                                       flexCollectorService: Services.FlexCollectorService) => {
                return new StreamMonitorDirective($interval,
                                                  $timeout,
                                                  $location,
                                                  streamStatusService,
                                                  streamPipeService,
                                                  connectionRoomService,
                                                  modalService,
                                                  networkNodeService,
                                                  $q,
                                                  timezoneService,
                                                  $cookies,
                                                  alarmsService,
                                                  stompService,
                                                  flexCollectorService);
            };
            directive.$inject = ['$interval',
                                 '$timeout',
                                 '$location',
                                 'streamStatusService',
                                 'streamPipeService',
                                 'connectionRoomService',
                                 'ModalService',
                                 'networkNodeService',
                                 '$q',
                                 'timezoneService',
                                 '$cookies',
                                 'alarmsService',
                                 'stompService',
                                 'flexCollectorService',
                                 ];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(private $interval: angular.IIntervalService,
                    private $timeout: angular.ITimeoutService,
                    private $location: ng.ILocationService,
                    private streamStatusService: Services.StreamStatusService,
                    private streamPipeService: Services.StreamPipeService,
                    private connectionRoomService: Services.ConnectionRoomService,
                    private modalService: ngModal.IModalService,
                    private networkNodeService: Services.NetworkNodeService,
                    private $q: ng.IQService,
                    private timezoneService: Services.TimezoneService,
                    private $cookies: ng.cookies.ICookiesService,
                    private alarmsService: Services.AlarmsService,
                    private stompService: Services.StompService,
                    private flexCollectorService: Services.FlexCollectorService) {

            StreamMonitorDirective.prototype.link = (scope: IStreamMonitorScope, element: JQuery, attrs: ng.IAttributes) => {
                let alarmInfoLoaded: boolean = false;

                scope.thumbnailLoadedWatcher = scope.$watch('thumbnail', (newVal: string, oldVal: string) => {
                    const imgTag: JQuery = $(element).find('.monitor-thumbnail-source-img');
                    if (newVal !== oldVal && !!newVal && imgTag.length > 0) {
                        $(imgTag).bind('load', () => {
                            if (!alarmInfoLoaded) {
                                this.$timeout(() => {
                                    this.getAlarmsInfo(scope);
                                }, 3000);
                            }
                            alarmInfoLoaded = true;
                        });
                    }
                });
                scope.$on('$destroy', () => {
                    const imgTag: JQuery = $(element).find('.monitor-thumbnail-source-img');
                    if (imgTag.length > 0) {
                        $(imgTag).unbind('load');
                    }
                    scope.thumbnailLoadedWatcher();
                });

                let streamId: number = Utils.idFromHref(scope.model.source);
                let streamHref: string = streamId.toString();
                this.initVariables(scope);
                this.getStreamNodesInfo(streamHref).then((status: IStreamPipe) => {
                    scope.streamPipe = status;
                    this.registerStompServices(scope);
                    this.getBlockData(scope, streamHref);
                });

                scope.seeStream = () => {
                    $location.path('/stream/' + streamId);
                };

                scope.showHistoricalTraffic = () => {
                    $location.path('/historical/' + streamId);
                };

                scope.loadVideoFeed = (initial?: boolean) => {
                    if (initial) {
                        // direct call, as we want the thumbnail as soon as possible
                        connectionRoomService
                            .getVideoFeedPromiseByStreamPipeIdNoList(streamId.toString())
                            .then((videoFeed: VideoFeed) => {
                                if (videoFeed.status !== Models.VideoFeedStatus.ERROR && !videoFeed.equals(scope.videoFeed)) {
                                    scope.videoFeed = videoFeed;
                                    scope.thumbnail = this.getThumbnailUrl(scope.videoFeed);
                                }
                            });
                    } else {
                        connectionRoomService
                            .getVideoFeedPromiseByStreamPipeId(streamId.toString())
                            .then((videoFeed: VideoFeed) => {
                                if (videoFeed.status !== Models.VideoFeedStatus.ERROR && !videoFeed.equals(scope.videoFeed)) {
                                    scope.videoFeed = videoFeed;
                                }
                            });
                    }
                };

                scope.bulkConfirm = () => {
                    modalService
                        .showModal({
                            templateUrl: Application.Controllers.AcknowledgeAllModalController.templateURL,
                            controller: Application.Controllers.AcknowledgeAllModalController.$name,
                            inputs: {
                                monitorName: scope.model.name,
                                sourceName: scope.sourceNode.alias ? scope.sourceNode.alias : scope.sourceNode.name,
                                sinkName: scope.sinkNode.alias ? scope.sinkNode.alias : scope.sinkNode.name,
                                extraNames: []
                            },
                        })
                        .then((modal: ngModal.IModalObject) => {
                            let acknowledgeModalElem: UIkit.ModalElement =
                                UIkit.modal(Application.Controllers.AcknowledgeAllModalController.ID,
                                            { bgclose: false, modal: false, keyboard: false });
                            acknowledgeModalElem.show();
                            modal.close.then((result: string) => {
                                acknowledgeModalElem.hide();
                                if (result !== undefined) {
                                    scope.alarmsConfirming = true;  
                                    alarmsService.confirmEveryAlarmForDevices('blocks/' + scope.streamPipe.sourceBlockId,
                                                                            'blocks/' + scope.streamPipe.sinkBlockId,
                                                                            result !== '' ? result : 'Bulk confirm')
                                                                            .then(() => {
                                                                                scope.alarmsConfirming = false;
                                                                            });
                                    alarmsService.confirmEveryAlarmForDevices('networkNodes/' + scope.streamPipe.sourceNodeHref,
                                                                            'networkNodes/' + scope.streamPipe.sinkNodeHref,
                                                                            result !== '' ? result : 'Bulk confirm')
                                                                            .then(() => {
                                                                                scope.alarmsConfirming = false;
                                                                            });
                                }
                            });
                        });
                };

                scope.videoTimer = $interval(() => {
                    scope.loadVideoFeed();
                }, StreamMonitorDirective.VIDEOFEED_TIMER + Common.Utils.randomNumber(1000));

                scope.loadVideoFeed(true);
                scope.thumbnailTimer = $interval(() => {
                    scope.thumbnail = this.getThumbnailUrl(scope.videoFeed);
                }, StreamMonitorDirective.THUMBNAIL_TIMER + Common.Utils.randomNumber(1000));

                this.getData(scope, streamHref);
                scope.dataTimer = $interval(() => {
                    this.getData(scope, streamHref);
                }, StreamMonitorDirective.STREAM_DATA_TIMER + Common.Utils.randomNumber(1500));

                scope.onPlotHover = (event: JQueryEventObject, pos: jquery.flot.pos, item: jquery.flot.item) => {
                    this.onPlotHover(event, pos, item);
                };

                scope.$on('$destroy', () => {
                    if (scope.dataTimer)
                        $interval.cancel(scope.dataTimer);

                    if (scope.thumbnailTimer)
                        $interval.cancel(scope.thumbnailTimer);

                    if (scope.videoTimer)
                        $interval.cancel(scope.videoTimer);

                    if (scope.subscriptionCreate)
                        stompService.unregister(scope.subscriptionCreate);

                    if (scope.subscriptionBulkConfirm) {
                        stompService.unregister(scope.subscriptionBulkConfirm);
                    }

                    if (scope.subscriptionSingleConfirm) {
                        stompService.unregister(scope.subscriptionSingleConfirm);
                    }

                    if (scope.subscriptionBulkConfirm) {
                        stompService.unregister(scope.subscriptionBulkConfirmAll);
                    }

                    let placeholder: JQuery = $("#trending-monitor-" + scope.model.numOrder + '');
                    if (placeholder.length > 0) {
                        placeholder.off('plothover');
                    }

                });
            };
        }

        public onPlotHover (event: JQueryEventObject, pos: jquery.flot.pos, item: jquery.flot.item): void {
            let previousPoint: number[] = [];

            if (item) {
                if (previousPoint !== item.datapoint) {
                    previousPoint = item.datapoint;
                    $("#tooltip").hide();
                    let y: string = item.datapoint[1].toFixed(2);
                    $("#tooltip")
                        .css({top: item.pageY - 35, left: item.pageX - 60})
                        .html("<span>" + y + " Mbps</span>").show();
                }
            } else {
                $("#tooltip").hide();
                previousPoint = undefined;
            }
        }

        private getThumbnailUrl(videoFeed: IVideoFeed): string {
            if (videoFeed && videoFeed.thumbnailUrl !== "") {
                if (videoFeed.forceRefreshThumbnail)
                    return videoFeed.thumbnailUrl + "?&" + Common.Utils.getCurrentTimestamp();
                else
                    return videoFeed.thumbnailUrl;
            }
            else
                return StreamMonitorDirective.THUMBNAIL_FAIL_IMG;
        }

        private bitsToMbps(bits: number): number {
            return parseFloat((bits / 1000000).toFixed(2));
        }

        /**
         * Update the graph with data from a new call to the service
         */
        private getData(scope: IStreamMonitorScope, streamHref: string): void {
            // trending!
            if (scope.bitRateTrending.length === 0)
                this.streamStatusService.getStreamPipeTrendingData(streamHref, false)
                .then((status: IBitRateTrending[]) => {
                    status.forEach((brt: IBitRateTrending) => {
                        brt.bitrate = this.bitsToMbps(brt.bitrate);
                    });
                    if (status.length > 0) {
                        scope.totalCurrentBitrate =  status[status.length - 1].bitrate + " Mbps";
                    } else {
                        scope.totalCurrentBitrate = "0 Mbps";
                    }
                    scope.bitRateTrending = status;
                    
                    this.plotGraph(scope, streamHref);
                });
            else {
                let last: IBitRateTrending = scope.bitRateTrending[scope.bitRateTrending.length - 1];
                this.streamStatusService.getStreamPipeTrendingDataFromSeconds(
                        streamHref, 13 , 6, false)
                .then((status: IBitRateTrending[]) => {
                    status.forEach((brt: IBitRateTrending) => {
                        if (brt.date > last.date) {
                            brt.bitrate = this.bitsToMbps(brt.bitrate);
                            scope.bitRateTrending.push(brt);
                            scope.bitRateTrending.splice(0, 1);
                        }
                    });
                    if (status.length > 0) {
                        scope.totalCurrentBitrate =  scope.bitRateTrending[scope.bitRateTrending.length - 1].bitrate + " Mbps";
                    } else {
                        scope.totalCurrentBitrate = "0 Mbps";
                    }
                    
                    this.plotGraph(scope, streamHref);
                });
            }

            if (scope.sourceNode === undefined || scope.sinkNode === undefined) {
                this.streamPipeService
                    .getStreamPipeNodesHrefByStreamId(parseInt(streamHref, 10))
                    .then((res: IStreamPipeNodes) => {
                        let source: number = parseInt(res.sourceHref, 10);
                        let sink: number = parseInt(res.sinkHref, 10);
                        let calls: (ng.IPromise<NetworkNode>)[];
                        if (!isNaN(source) && !isNaN(sink))
                            calls = [ this.networkNodeService.getByIdPromise(source), this.networkNodeService.getByIdPromise(sink) ];
                        else if (!isNaN(source))
                            calls = [ this.networkNodeService.getByIdPromise(source) ];
                        else if (!isNaN(sink))
                            calls = [ this.networkNodeService.getByIdPromise(sink) ];
                        else
                            calls = [];
                        this.$q.all(calls)
                        .then((nodes: NetworkNode[]) => {
                            scope.sourceNode = nodes[0];
                            scope.sinkNode = nodes[1];
                            let sourceHealth: string = scope.sourceNode.health.data.healthStatus;
                            let sinkHealth: string = scope.sinkNode.health.data.healthStatus;
                            if (sourceHealth === 'OFFLINE' || sinkHealth === 'OFFLINE' || !sourceHealth || !sinkHealth)
                                scope.monitorStatus = 'OFFLINE';
                            else if (sourceHealth === 'ONLINE' && sinkHealth === 'ONLINE')
                                scope.monitorStatus = 'ONLINE';
                            else
                                scope.monitorStatus = 'PENDING';
                        });
                    });
            } else {
                let sourceHealth: string = scope.sourceNode.health.data.healthStatus;
                let sinkHealth: string = scope.sinkNode.health.data.healthStatus;
                if (sourceHealth === 'OFFLINE' || sinkHealth === 'OFFLINE')
                    scope.monitorStatus = 'OFFLINE';
                else if (sourceHealth === 'ONLINE' && sinkHealth === 'ONLINE')
                    scope.monitorStatus = 'ONLINE';
                else
                    scope.monitorStatus = 'PENDING';
            }
        }

        private getBlockData(scope: IStreamMonitorScope, streamHref: string): ng.IPromise<void> {
            return this.flexCollectorService.getDeviceParamsBySimplifiedHrefGrouped("blocks", scope.streamPipe.sourceBlockId)
                    .then((deviceParams: Models.DeviceParams) => {
                        const detectedFormatParams: Models.DeviceParam[] = deviceParams.getParamsBySuffix("detectedFormat");
                        if (detectedFormatParams && detectedFormatParams.length > 0) {
                            scope.serviceInfo = {};
                            scope.serviceInfo.encoding = detectedFormatParams[0].lastValue as string;
                        }
                        return;
                    });
        }

        private plotGraph(scope: IStreamMonitorScope, streamHref: string): void {
            let thresholdValue: number;
            let thresholdEnabled: string =
                this.$cookies.get(StreamMonitorDirective.COOKIE_THRESHOLD_ENABLED_KEY + streamHref);
            
            if (thresholdEnabled === 'true') {
                thresholdValue = parseFloat(this.$cookies.get(StreamMonitorDirective.COOKIE_THRESHOLD_VALUE_KEY + streamHref));
            }

            let dataToPlot: number[][] = new Array();
            let offset: string = this.timezoneService.getEffectiveOffset();
            let yMax: number = 1;
            scope.bitRateTrending.forEach((bitRateTrending: IBitRateTrending) => {
                let dateOffseted: string = bitRateTrending.date.slice(0, -5) + offset;
                dataToPlot.push([new Date(dateOffseted).valueOf(), bitRateTrending.bitrate]);
                if (yMax < bitRateTrending.bitrate) yMax = bitRateTrending.bitrate;
            });

            let mainSeries: jquery.flot.dataSeries = { data: dataToPlot, points: { show: false}};
            let yaxisMax: number = (thresholdValue) ? Math.max(Math.ceil(yMax), thresholdValue + 0.5) : Math.ceil(yMax);


            scope.graphOptions.yaxis.max = yaxisMax;

            let series: Object[];
            if (thresholdValue === undefined) {
                series = [mainSeries];
            } else {
                series = [mainSeries, {
                    data:  [
                        [dataToPlot[0][0], thresholdValue],
                        [dataToPlot[dataToPlot.length - 1][0], thresholdValue],
                    ],
                    points: { show: false },
                    lines: {
                        show: true, fill: false,
                        opacity: 1,
                    },
                    color: 'red',
                }];
            }

            scope.plotSeries = series;
            this.$timeout(() => {
                // hack to fix the wrong y-axis scale on graph loading
                scope.plotSeries = series;
            }, 100);
                    

        }

        private getAlarmsInfo(scope: IStreamMonitorScope): void {
            // Some alarms are block level, but some other (like temperature) are still device level
            let baseHref: string = 'networkNodes/';
            let baseHrefBlocks: string = 'blocks/';
            let promises: ng.IPromise<{}>[] = [
                this.alarmsService.getAlarmsInfoFromSimplifiedHref(baseHref + scope.streamPipe.sourceNodeHref),
                this.alarmsService.getAlarmsInfoFromSimplifiedHref(baseHref + scope.streamPipe.sinkNodeHref),
                this.alarmsService.getAlarmsInfoFromSimplifiedHref(baseHrefBlocks + scope.streamPipe.sourceBlockId),
                this.alarmsService.getAlarmsInfoFromSimplifiedHref(baseHrefBlocks + scope.streamPipe.sinkBlockId),
            ];

            scope.alarmsInfo = {
                    currentCriticals: [],
                    allCount: 0,
                    criticalsCount: 0,
                };

            this.$q.all(promises).then((devicesAlarmsInfo: Models.IAlarmsInfo[]) => {
                for (let deviceAlarmsInfo of devicesAlarmsInfo) {
                    // we don't want the red frame if there is not a stream active
                    if (Common.Utils.exists(scope.streamPipe)) {
                        let currentAlarms: Models.IAlarm[] = deviceAlarmsInfo.currentAlarms;
                        for (let alarm of currentAlarms) {
                            if (!alarm.confirmed && !alarm.masked && (alarm.level === 0 || alarm.level === 8)) {
                                scope.alarmsInfo.currentCriticals.push({
                                    alarmName: alarm.name,
                                    deviceSimplifiedHref: alarm.deviceId,
                                });
                            }
                        }
                    }
                    scope.alarmsInfo.allCount += deviceAlarmsInfo.allNonHidden;
                    scope.alarmsInfo.criticalsCount += deviceAlarmsInfo.criticalNonHidden;
                }
            });
        }

        private getStreamNodesInfo(streamHref: string): ng.IPromise<IStreamPipe> {
            return this.streamPipeService.getStreamPipe(streamHref, false)
                .then((status: IStreamPipe) => {
                    return status;
                });
        }

        private initVariables(scope: IStreamMonitorScope): void {
            // used from fullscreenActivate and fullscreenDeactivate directives
            scope.THUMBNAIL_FAIL_IMG = StreamMonitorDirective.THUMBNAIL_FAIL_IMG;
            scope.thumbnail = StreamMonitorDirective.THUMBNAIL_LOADING_IMG;
            
            scope.videoFeed = VideoFeed.Empty();
            scope.bitRateTrending = [];
            scope.sourceNode = undefined;
            scope.sinkNode = undefined;
            scope.monitorStatus = 'PENDING';
            scope.graphOptions = {
                colors: ['#22C969'],
                series: {
                    lines: {
                        show: true,
                        lineWidth: 2.0,
                        fill: true,
                    },
                    curvedLines: {
                        active: true,
                        apply: true,
                    },
                },
                grid: {
                    hoverable: true,
                    backgroundColor: "#333",
                    markings: [],
                },
                axisLabels: {
                    show: true,
                },

                xaxis: {
                    mode: "time",
                    // timezone: "browser",
                    tickSize: [60, "second"],
                    tickColor: "#444",
                    axisLabelColour: "darkgray",
                },
                yaxis: {
                    position: 'left',
                    axisLabel: 'Mbps',
                    axisLabelPadding: 5,
                    axisLabelFontSizePixels: 12,
                    axisLabelColour: "darkgray",
                    axisLabelUseCanvas: true,
                    tickColor: "#444",
                    min: 0,
                },
                legend: false,
            };
        }

        private registerStompServices(scope: IStreamMonitorScope): void {
            const hrefs: string[] =  [
                'networkNodes/' + scope.streamPipe.sourceNodeHref,
                'networkNodes/' + scope.streamPipe.sinkNodeHref,
                'blocks/' + scope.streamPipe.sourceBlockId,
                'blocks/' + scope.streamPipe.sinkBlockId,
            ];

            let kafka: string = Models.ALARMS_COMPONENT;
            let alarmCreated: string = Models.CREATE_OPERATION;
            let flexo: string = Models.FLEXO_COMPONENT;
            let alarmConfirm: string = Models.CONFIRM_ALARM_OPERATION;
            let alarmBulkConfirm: string = Models.BULK_CONFIRM_OPERATION;
            let alarmBulkConfirmAll: string = Models.BULK_CONFIRM_ALL_OPERATION;

            scope.subscriptionCreate = this.stompService.register(kafka, alarmCreated, (flexEvent: Models.IFlexEvent) => {
                let alarm: Models.Alarm = flexEvent.data as Models.Alarm;
                if ( hrefs.indexOf(alarm.deviceId) > -1 ) {
                    this.getAlarmsInfo(scope);
                }
            });

            scope.subscriptionSingleConfirm = this.stompService.register(flexo, alarmConfirm, (flexEvent: Models.IFlexEvent) => {
                let alarm: Models.Alarm = flexEvent.data as Models.Alarm;
                if ( hrefs.indexOf(alarm.deviceId) > -1 ) {
                    this.getAlarmsInfo(scope);
                }
            });

            scope.subscriptionBulkConfirm = this.stompService.register(kafka, alarmBulkConfirm, (flexEvent: Models.IFlexEvent) => {
                let bulk: { destHref: string, sourceHref: string } = flexEvent.data as { destHref: string, sourceHref: string };
                if ( hrefs.indexOf(bulk.sourceHref) > -1 || hrefs.indexOf(bulk.destHref) > -1 ) {
                    this.getAlarmsInfo(scope);
                }
            });

            scope.subscriptionBulkConfirmAll = this.stompService.register(kafka, alarmBulkConfirmAll, (flexEvent: Models.IFlexEvent) => {
                this.getAlarmsInfo(scope);
            });
        }
    }
}
